import { render, staticRenderFns } from "./ProjectBidSummaryFullscreen.vue?vue&type=template&id=ef4f3ec2"
import script from "./ProjectBidSummaryFullscreen.vue?vue&type=script&lang=js"
export * from "./ProjectBidSummaryFullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports